import { useMutation, useQueryClient } from '@tanstack/react-query';
import { EditIcon, Trash2Icon } from 'lucide-react';
import type { Dispatch, SetStateAction } from 'react';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import type { Bookmark } from '@/types/bookmarks';
import { factory } from '@/utils/queryFactory';
import { BOOKMARKS_QUERY_KEY } from '@/utils/queryFactory/resources/bookmarks';

export const ActionButtons = ({
  bookmark,
  setEditId,
}: {
  bookmark: Bookmark;
  setEditId: Dispatch<SetStateAction<number | null>>;
}) => {
  const queryClient = useQueryClient();
  const deleteBookmark = useMutation({
    ...factory.bookmarks.deleteBookmark({ bookmarkId: bookmark.id }),
    async onSuccess() {
      queryClient.invalidateQueries({ queryKey: [BOOKMARKS_QUERY_KEY] });
    },
  });

  return (
    <TooltipProvider delayDuration={200}>
      <div className='flex gap-2'>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant='default'
              size='icon'
              className='px-2 py-1'
              onClick={(e) => {
                e.stopPropagation();
                setEditId(bookmark.id);
              }}
            >
              <EditIcon
                strokeWidth={1.5}
                className='h-4 w-4'
              />
            </Button>
          </TooltipTrigger>
          <TooltipContent
            side='bottom'
            align='center'
          >
            <p className='block max-w-60 whitespace-pre-wrap'>Redigera bokmärke</p>
          </TooltipContent>
        </Tooltip>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant='destructive'
              size='icon'
              className='px-2 py-1'
              onClick={(e) => {
                e.stopPropagation();
                deleteBookmark.mutate();
              }}
            >
              <Trash2Icon
                strokeWidth={1.5}
                className='h-4 w-4'
              />
            </Button>
          </TooltipTrigger>
          <TooltipContent
            side='bottom'
            align='center'
          >
            <p className='block max-w-60 whitespace-pre-wrap'>Ta bort bokmärke</p>
          </TooltipContent>
        </Tooltip>
      </div>
    </TooltipProvider>
  );
};
